<template>
    <div>
        <search v-model="search" @search="fetchPlans" placeholder="Search by plan name..."></search>
        <div class="row mb-4">
            <div class="col">
                <button class="btn btn-sm btn-primary float-right" @click="newPlan"><i class="fa fa-plus mr-2"></i>New
                    Plan
                </button>
            </div>
        </div>
        <modal ref="planModal" size="lg"><span slot="title">Plan Form</span>
            <kiosk-plan-form v-model="plan" ref="planForm" @saved="saved"></kiosk-plan-form>
            <div slot="footer">
                <button class="btn btn-default" @click="close">Cancel</button>
                <button-loading class="btn btn-primary ml-2" @click="save" :loading="plan.submitting">Save
                </button-loading>
            </div>
        </modal>
        <card>
            <card-body class="pt-0" v-if="loading">
                <card-spinner class="mt-3" size="large" style="height: 100px"></card-spinner>
            </card-body>
            <card-body class="p-0" v-if="!loading">
                <kiosk-plan-table :plans="plans.data"></kiosk-plan-table>
                <pagination :meta="plans.meta" :links="plans.links" @page="fetchPlans"></pagination>
            </card-body>
        </card>
    </div>
</template>

<script>
    export default {
        data: () => ({
            search: null,
            plan: new Form(),
            loading: true,
            page: 1,
            plans: {
                data: [],
            },
            options: {title: 'Plan Created', type: 'success', text: 'Your custom plan was created successfully.'}
        }),

        created() {
            this.fetchPlans();
        },

        methods: {
            fetchPlans(page = 1) {
                return this.$http.get(this.$laroute.route('api.plans.index'))
                    .then(response => {
                        this.loading = false;
                        this.plans = response.data;
                    });
            },

            newPlan() {
                this.$refs.planModal.open();
                this.plan = new Form();
            },

            close() {
                this.$refs.planModal.close();
            },

            save() {
                this.$refs.planForm.save()
                    .then(() => {
                        swal.fire(this.options).then(() => {
                            this.$refs.planModal.close();
                        });
                    });
            },

            saved() {
                this.fetchPlans();
            },
        },
    };
</script>
